import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as moment from 'moment';
import { IDatePickerConfig } from 'ng2-date-picker';
import { LazyLoadEvent, SortEvent } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { DocuwareCabinetReuestModel, DocuwareFieldData } from 'src/app/models/request/cabinet-request';
import { DocumentTypeDocumentSearchRequestModel } from 'src/app/models/request/document-type-document-request';
import { MetadataSearchModel, MetadataSearchRequestModel } from 'src/app/models/request/metadata-search-request';
import { CompanyResponseModel } from 'src/app/models/response/company-response';
import { CompanyResponseModelForCustom, DocumentTypeResponseModelForCustom, InceptionCustomAuthModel, InceptionCustomAuthResponseModel } from 'src/app/models/response/custom-auth';
import { DocumentDisplayModel, SearchInputModel, LabelValueModel, SPFullTextModel, FilterValueModel, DocumentTypeDocumentModelForSearch } from 'src/app/models/response/document-type-document-response';
import { DocumentTypeResponseModel, DocumentTypeListResponseModel } from 'src/app/models/response/document-type-response';
import { DocuwareRecordsModel } from 'src/app/models/response/docuware-fields';
import { ForgotPasswordModel, DownloadFile } from 'src/app/models/response/forgot-password';
import { PagedResult, ResultOfT } from 'src/app/models/response/result';
import { SearchableFieldResponseModel } from 'src/app/models/response/searchable-field-response';
import { SearchableFieldValueResponseModel } from 'src/app/models/response/searchable-field-value-response';
import { DocumentCabinetService } from 'src/app/services/document-cabinet.service';
import { DocuwareCabinetService } from 'src/app/services/docuware-cabinet.service';
import { BaseComponent } from 'src/app/shared/base.component';
import { Constants } from 'src/app/shared/constants';
import { enumDatabaseType, enumFieldTypes, UserRole } from 'src/app/shared/enum';
import { environment } from 'src/environments/environment';
declare var Tiff: any;
import { saveAs as importedSaveAs } from 'file-saver';
import * as $ from 'jquery';
import { DocumentResponseModel, DocumentTypesModel, DynamicDocumentTypeInbox, SearchCondition, SearchInputModelForDynamicObj, SearchMetadataModel, SearchMetadataRequestModel, SearchRawDataForDynamicObjectModel } from 'src/app/models/response/document-search-model';
import { DocumentServiceService } from 'src/app/services/document-service.service';
import { UserAuthResponseModel } from 'src/app/models/response/access-token-response';
import { WebStorageService } from 'src/app/services/web-storage.service';
import { PermissionModel } from 'src/app/models/request/document-type-request';
import { PermissionService } from 'src/app/services/permission.service';
declare var NutrientViewer: any;

@Component({
  selector: 'app-new-inception-custom-web-page',
  templateUrl: './new-inception-custom-web-page.component.html',
  styleUrls: ['./new-inception-custom-web-page.component.sass'],
  styles: [`
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          position: inherit;
          top: 0;
      }

      .layout-news-active :host ::ng-deep .p-datatable tr > th {
          top: 0;
      }
  `]
})
export class NewInceptionCustomWebPageComponent extends BaseComponent implements OnInit, OnDestroy {
  documentTypeInboxId: any;
  isOfficeDoc: boolean;
  companyId: any;
  selectedDocumentTypeList: DocumentTypesModel;
  isMapped: boolean = true;
  @ViewChild('printBtn', { static: false }) printBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('nutrientViewer', { static: false }) nutrientViewerElement!: ElementRef<HTMLDivElement>;
  nutrientInstance: any;
  permissionresp: PermissionModel[] = [];
  isViewerPrint: boolean = false;
  documentTypeId: number;
  isView: boolean = false;
  isEdit: boolean = false;
  isDelete: boolean = false;
  isViewerEdit: boolean = false;
  isViewerDownload: boolean = false;
  isViewerSearch: boolean = false;
  isCustomer: boolean = false;


  zoomIn(): void {
    this.currentZoom = Math.min(this.currentZoom + 0.1, 3);
    this.setZoomClass();
  }

  zoomOut(): void {
    this.currentZoom = Math.max(this.currentZoom - 0.1, 0.3);
    this.setZoomClass();
  }

  setZoomClass(): void {
    this.zoomClass = this.currentZoom !== 1 ? 'zoom-active' : '';
  }

  toggleClass() {
    this.isActive = !this.isActive;
  }

  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();

  queryString: string = '';
  cardImageBase64: string = '';
  documentViewerLink: string = '';

  cabinetRequestModel: DocuwareCabinetReuestModel;
  customAuthResponseModel: InceptionCustomAuthModel;
  docuwareRecordsModel: DocuwareRecordsModel[];
  docuwareSearchControlModel: DocuwareRecordsModel[];
  docuwareRecordsBackup: DocuwareRecordsModel[];
  // municipalityResponseModel: MunicipalityResponseModel;
  documentTypeResponseModel: DocumentTypeResponseModelForCustom;
  companyResponseModel: CompanyResponseModelForCustom;
  // documents: DocumentTypeDocumentResponseModel[];
  documents: DocumentDisplayModel[];

  headers: any[];
  records: any[];
  backupRecords: any[];
  searchRecords: Array<any>;
  searchRecordsTemp: any[];
  backupSearchRecords: any[];
  searchFilterData: any;
  searchFilterDataTemp: Array<any>;
  // isSearch: boolean = false;
  displayClearButton: boolean = false;

  viewerLoader: boolean = false;
  customLoader: boolean = false;
  totalRecordCount: number = 0;
  pageCount: number = 1;
  pageSize: number = 1000;
  pageArray: Array<number>;
  paginationPage: number;
  startRecord: number;
  endRecord: number;
  displayPagination: boolean = true;
  enumDatabaseType: enumDatabaseType;
  isInitialEmptyState: boolean = true;

  selectedValue: any;
  filterResposniveEvent: any;
  searchInputList: SearchInputModelForDynamicObj[];
  enumFieldType: enumFieldTypes;
  FilterValues: LabelValueModel[];

  forgotPasswordRequestModel: ForgotPasswordModel;

  isMore: boolean = false;

  displayMessage: boolean = false;
  message: string = '';
  messageClass: boolean;
  config: IDatePickerConfig = {
    format: 'MM/DD/YYYY'
  };

  searchLoader: boolean = true;
  isDocuware: boolean = false;
  showSearchPanel: boolean = false;
  searchableFieldModel: SearchableFieldResponseModel[];
  isSearchHasData: boolean;
  forSepcialCompanyDb: boolean = false;

  filePath: string;
  fileName: string = '';
  fileExtension: string = '';
  DocumentViewerPopup: boolean;
  documentTypeList: DocumentTypesModel[];
  selectedDocumentType: DocumentTypesModel;
  selectedFileId: number;
  listOfFullTextSearchedDocIds: SPFullTextModel[];
  fullTextSearch: string = '';
  metadataSearchModel: MetadataSearchModel[];
  FilterValuesForSpecialCompanies: SearchableFieldValueResponseModel[];
  isImage: boolean;
  isPdf: boolean;
  base64String: string;
  optionList: FilterValueModel[] = [];
  yearRange = '';
  isLazyLoadingEnabled: boolean = false;
  totalRecords: number;
  pageNumber: number = 1;
  lazyPageSize: number = 50;
  sortField: string;
  sortOrder: number = -1;
  matchType: string = 'All';
  tableVisible: boolean = true;
  pdfSrc: SafeResourceUrl;
  userId: number;
  currentUserToken: UserAuthResponseModel;

  isActive: any;
  currentZoom: any;
  zoomClass: any;
  documentTypeDocumentId: any;
  isNutrientViewer: any;


  constructor(private router: Router, private activatedRoute: ActivatedRoute, private docuwareCabinetService: DocuwareCabinetService, private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder, private documentCabinetService: DocumentCabinetService,
    private cd: ChangeDetectorRef, private permissionService: PermissionService,
    private documentService: DocumentServiceService,
    private webStorageService: WebStorageService, private cdr: ChangeDetectorRef) {
    super();

    this.currentUserToken = this.webStorageService.getCurrentUserToken();
    this.userId = this.currentUserToken.userId;
    this.isCustomer = this.currentUserToken.role === UserRole.enumCustomer ? true : false;
    // this is for routerLink on same component when only queryParameter changes 
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  GetPermissionByUserId() {
    if (this.documentTypeId == null || this.userId == null) {
      return;
    }

    // Reset everything first (IMPORTANT)
    this.isView = false;
    this.isEdit = false;
    this.isDelete = false;
    this.isViewerEdit = false;
    this.isViewerDownload = false;
    this.isViewerSearch = false;
    this.isViewerPrint = false;

    this.permissionService
      .GetPermissionByUserId(this.userId, this.documentTypeId)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe({
        next: (result: ResultOfT<PermissionModel[]>) => {
          if (result?.IsSuccess && result.ResponseModel) {

            this.permissionresp = result.ResponseModel;
            this.permissionresp.forEach((perm) => {
              const name = perm.PermissionName;

              if (this.isCustomer) {
                this.permissionresp.forEach((perm) => {
                  const name = perm.PermissionName;

                  if (name === 'View') this.isView = true;
                  else if (name === 'Edit') this.isEdit = true;
                  else if (name === 'Delete') this.isDelete = true;
                  else if (name === 'ViewerEdit') this.isViewerEdit = true;
                  else if (name === 'ViewerDownload') this.isViewerDownload = true;
                  else if (name === 'ViewerSearch') this.isViewerSearch = true;
                  else if (name === 'ViewerPrint') this.isViewerPrint = true;
                });
              } else {
                this.isView = true;
                this.isEdit = true;
                this.isDelete = true;
                this.isViewerEdit = true;
                this.isViewerDownload = true;
                this.isViewerSearch = true;
                this.isViewerPrint = true;
              }
            });
          } else {
            this.timeoutFunct(result?.Message, false);
          }
        },
        error: (err) => {
          this.timeoutFunct(err?.message, false);
        }
      });
  }

  filter() {
    this.isInitialEmptyState = false;
    this.loading = true;
    this.customLoader = true;
    var that = this;


    this.cabinetRequestModel.DocuwareFieldData = new Array<DocuwareFieldData>();
    var docuFieldData = new DocuwareFieldData();
    if (this.forSepcialCompanyDb) {
      this.searchableFieldModel.forEach(searchBox => {
        docuFieldData = new DocuwareFieldData();

        var searchValue = this.form.get(searchBox.FieldName)?.value;
        if (searchValue) {
          if (searchBox.FieldType === 'Date') {
            const momentDateValue = moment(searchValue, 'MM/DD/YYYY');
            var dateValue = momentDateValue.format('MM/DD/YYYY');
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = dateValue;
          }
          else if (searchBox.FieldType !== 'Date' && searchBox.DisplayAs == 'Full Text') {
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = searchValue;
          }
          else {
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = searchValue.FieldValue;
          }

          this.cabinetRequestModel.DocuwareFieldData.push(docuFieldData);
        }
      });
    }
    else {
      this.searchInputList.forEach(searchBox => {
        docuFieldData = new DocuwareFieldData();

        var searchValue = this.form.get(searchBox.FieldName)?.value;
        if (searchValue) {

          if (searchBox.FieldType == 'Date') {
            const momentDateValue = moment(searchValue, 'MM/DD/YYYY');
            var dateValue = momentDateValue.format('MM/DD/YYYY');
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = dateValue;
          }
          else if (searchBox.FieldType !== 'Date' && searchBox.DisplayAs == 'Full Text') {
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = searchValue;
          }
          else {
            docuFieldData.FieldName = searchBox.FieldName;
            docuFieldData.FieldValue = searchValue.label;
            docuFieldData.FieldValue = (searchValue.label !== undefined) ? searchValue.label : searchValue;
          }

          this.cabinetRequestModel.DocuwareFieldData.push(docuFieldData);
        }
      });
    }

    if (this.cabinetRequestModel.ServerURL === 'https://nashuanh.docuware.cloud') {
      docuFieldData = new DocuwareFieldData();
      docuFieldData.FieldName = 'PUBLIC_STATUS';
      docuFieldData.FieldValue = 'Public';

      this.cabinetRequestModel.DocuwareFieldData.push(docuFieldData);
    }
    this.docuwareCabinetService.fullTextSearch(this.cabinetRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<DocuwareRecordsModel[]>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {
              this.docuwareRecordsModel = result.ResponseModel;

              that.records = [];
              that.searchRecords = [];

              this.docuwareRecordsModel.forEach(docuwareRecord => {
                const record = {};

                record["DocumentId"] = docuwareRecord.DocuwareDocumentId;
                docuwareRecord.DocuwareFields.forEach(field => {
                  record[field.DisplayAs] = field.FieldValue;

                });

                that.records.push(record);
              });

              that.searchRecords = that.records;

              for (const prop in this.searchFilterData) {
                if (prop === 'Full Text') {
                  delete this.searchFilterData[prop];
                }
              }
              this.headers = [];

              this.headers.push({ headerName: "DocumentId", fieldType: 'Numeric', sequence: -1 });
              this.headers.push({ headerName: 'View', fieldType: 'Text', sequence: 0 });
              this.docuwareRecordsModel[0]?.DocuwareFields.forEach(field => {
                if (field.IsDisplay) {

                  this.headers.push({ headerName: field.DisplayAs, fieldType: field.FieldType, sequence: field.DisplaySequence });
                }
              });

              this.headers = this.headers.sort((a, b) => a.sequence - b.sequence);

              this.displayPagination = true;

              this.startRecord = ((this.cabinetRequestModel.PageNo - 1) * (this.pageSize)) + 1;
              this.endRecord = this.startRecord + this.searchRecords.length - 1;

              if (this.pageCount == this.paginationPage) {
                this.endRecord = this.totalRecordCount;
              }
            }
            this.displayPagination = false;
            this.loading = false;
            this.customLoader = false;

          }
          else {
            this.loading = false;
            this.customLoader = false;
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.customLoader = false;
        this.timeoutFunct(httpResponseError.message, false);
      });
  }

  filterInAppDocs() {

    this.isInitialEmptyState = false;
    this.loading = true;
    this.customLoader = true;

    if (this.fullTextSearch !== '' && this.fullTextSearch !== null && this.fullTextSearch !== undefined) {
      const reqModel = new DocumentTypeDocumentSearchRequestModel();
      reqModel.DocumentTypeId = this.documentTypeResponseModel?.DocumentTypeId;
      reqModel.SearchText = this.fullTextSearch;

      this.documentCabinetService.GetDocumentTypeDocumentIdsForFullText(reqModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
        .subscribe((result: ResultOfT<SPFullTextModel[]>) => {
          this.processResult<SPFullTextModel[]>(result, () => {
            if (result.IsSuccess) {

              if (result.ResponseModel) {
                this.listOfFullTextSearchedDocIds = new Array<SPFullTextModel>();
                if (result.ResponseModel.length > 0) {
                  this.listOfFullTextSearchedDocIds = result.ResponseModel;

                  var fullTextSearchedRecords = new Array<any>();
                  this.listOfFullTextSearchedDocIds.forEach(docId => {
                    const selectedRecord = this.backupRecords.filter((obj) => {
                      return obj['DocumentTypeInboxId']?.toString().toLowerCase() === docId.DocumentTypeInboxId.toString().toLowerCase();
                    });
                    if (selectedRecord !== undefined && selectedRecord !== null && selectedRecord.length > 0) {
                      fullTextSearchedRecords.push(selectedRecord[0]);
                    }
                  });

                  this.searchRecords = fullTextSearchedRecords;

                  if (this.metadataSearchModel.length > 0) {
                    this.searchRecordsTemp = fullTextSearchedRecords;
                    this.searchInMetadata();
                  }
                  else {
                    this.searchRecords = fullTextSearchedRecords;
                  }
                }
                else {
                  this.searchRecords = new Array<any>();
                }

              }
            }
            else {
              this.loading = false;

              this.timeoutFunct(result.Message, false);
            }
          });
        }, (httpResponseError) => {
          this.loading = false;

          this.timeoutFunct(httpResponseError.message, false);
        });

    } else {
      this.searchInMetadata();
    }
    this.loading = false;
    this.customLoader = false;
    this.searchLoader = false;
  }

  searchInMetadataOLD() {

    var that = this;
    this.searchFilterDataTemp.forEach(value => {

      if (value.FieldType === enumFieldTypes.enumInteger) {

        const result = that.searchRecords.filter((obj) => {
          return parseInt(obj[value.FieldName]) >= parseInt(value.FieldValueFrom) && parseInt(obj[value.FieldName]) <= parseInt(value.FieldValueTo);
        });
        that.searchRecords = result;
      }
      else if (value.FieldType === enumFieldTypes.enumDecimal || value.FieldType === enumFieldTypes.enumCurrency) {

        const result = that.searchRecords.filter((obj) => {
          return parseFloat(obj[value.FieldName]) >= parseFloat(value.FieldValueFrom) && parseFloat(obj[value.FieldName]) <= parseFloat(value.FieldValueTo);
        });
        that.searchRecords = result;
      }
      else if (value.FieldType === enumFieldTypes.enumDate) {

        const result = that.searchRecords.filter((obj) => {
          return (moment(obj[value.FieldName], 'MM/DD/YYYY').format('YYYY/MM/DD')) >= (moment(value.FieldValueFrom, 'MM/DD/YYYY').format('YYYY/MM/DD')) && (moment(obj[value.FieldName], 'MM/DD/YYYY').format('YYYY/MM/DD')) <= (moment(value.FieldValueTo, 'MM/DD/YYYY').format('YYYY/MM/DD'));
        });
        that.searchRecords = result;
      }
      else {
        const result = that.searchRecords.filter((obj) => {
          return obj[value.FieldName]?.toString().toLowerCase() === value.FieldValueFrom.toString().toLowerCase();
        });
        that.searchRecords = result;
      }

    });
  }

  searchInMetadata() {

    var reqModel = new MetadataSearchRequestModel();
    reqModel.DocumentTypeId = this.documentTypeResponseModel.DocumentTypeId;
    reqModel.forCustomPage = true;
    reqModel.MetadataSearch = this.metadataSearchModel;

    this.documentCabinetService.GetMetadataSearchData(reqModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<DocumentTypeDocumentModelForSearch>) => {
        this.processResult<DocumentTypeDocumentModelForSearch>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {

              if (result.ResponseModel.BackupSearchRecords?.length > 0) {
                if (!(this.listOfFullTextSearchedDocIds?.length > 0 && this.searchRecordsTemp?.length > 0)) {
                  this.searchRecordsTemp = this.backupSearchRecords;
                }
                var filteredRecords = this.searchRecordsTemp.filter(function (o1) {
                  return result.ResponseModel.BackupSearchRecords.some(function (o2) {
                    return o1['DocumentTypeInboxId'] === o2['DocumentTypeInboxId'];          // assumes unique id
                  });
                });

                if (filteredRecords.length > 0) {
                  this.searchRecords = filteredRecords;
                }
              }
              else {
                this.searchRecords = new Array<any>();
              }

            }
          }
          else {
            this.loading = false;

            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;

        this.timeoutFunct(httpResponseError.message, false);
      });

  }

  filterClickEvent() {
    this.filterResposniveEvent = !this.filterResposniveEvent;
  }


  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress) {
      this.progress.complete();
    }
  }

  ngOnInit(): void {
    this.yearRange = '1900:' + (new Date().getFullYear() + 50);
    this.searchFilterData = {};
    this.searchFilterDataTemp = new Array<any>();
    this.forgotPasswordRequestModel = new ForgotPasswordModel();
    this.documentTypeResponseModel = new DocumentTypeResponseModel();
    this.metadataSearchModel = new Array<MetadataSearchModel>();

    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((params: Params) => {

        this.queryString = params['queryString'];
      });

    if (this.queryString) {
      if (this.queryString.charAt(this.queryString.length - 1) !== '=') {
        this.forgotPasswordRequestModel.encryptedString = this.queryString + "=";
      } else {
        this.forgotPasswordRequestModel.encryptedString = this.queryString;
      }
      this.authenticateCustomPage();
    }
    this.paginationPage = parseInt($('.cdp').attr('actpage'), 10);
  }

  onPageClick(pagenumber: number) {
    this.cabinetRequestModel.PageNo = pagenumber;

    this.getFileCabinetRecordsById();

  }

  onSelectChange(event: any, searchBox: any) {

    if (event?.label) {
      this.form.controls[searchBox.FieldName]?.value;
      var searchValue = this.form.controls[searchBox.FieldName]?.value;
      if (searchValue) {
        if (this.searchFilterDataTemp == undefined) {
          this.searchFilterDataTemp = new Array<any>();
        }
        this.isDocuware ? this.searchFilterData[searchBox.DisplayAs] = searchValue : this.searchFilterDataTemp[searchBox.DisplayAs] = searchValue;
      } else {
        //delete this.searchFilterDataTemp[searchBox.DisplayAs];
      }
    }
    else {
      if (event?.FieldValue) {
        this.form.controls[searchBox.FieldName]?.setValue(event);
        var searchValue1 = this.form.controls[searchBox.FieldName]?.value;
        if (searchValue1) {
          if (this.searchFilterDataTemp == undefined) {
            this.searchFilterDataTemp = new Array<any>();
          }
          this.isDocuware ? this.searchFilterData[searchBox.DisplayAs] = searchValue1 : this.searchFilterDataTemp[searchBox.DisplayAs] = searchValue1;
        } else {
          //delete this.searchFilterDataTemp[searchBox.DisplayAs];
        }
      } else {
        if (searchBox?.DocumentTypeMetadataId == 0) {
          this.form.controls[searchBox.FieldName]?.setValue(event.value);
        }
        else {
          if (this.isDocuware) {
            this.form.get(searchBox.FieldName).setValue(null);
            if (this.searchFilterDataTemp?.length > 0) {
              this.isDocuware ? delete this.searchFilterData[searchBox.DisplayAs] : delete this.searchFilterDataTemp[searchBox.DisplayAs];
            }
            else {
              this.form.get(searchBox.FieldName).setValue(event?.value);
              this.searchFilterData[searchBox.DisplayAs] = this.form.get(searchBox.FieldName)?.value;
            }
          }
        }
      }
    }
  }

  onDropdownChange(event: any, searchBox: any) {

    if (event?.value) {

      this.form.get(searchBox.FieldName).setValue(event.value);
      var searchValue = this.form.get(searchBox.FieldName)?.value;
      if (searchValue) {
        if (this.searchFilterDataTemp == undefined) {
          this.searchFilterDataTemp = new Array<any>();
        }
        this.isDocuware ? this.searchFilterData[searchBox.DisplayAs] = searchValue : this.searchFilterDataTemp[searchBox.DisplayAs] = searchValue;
      } else {
        //delete this.searchFilterDataTemp[searchBox.DisplayAs];
      }
    }
    else {
      if (event?.FieldValue) {
        this.form.get(searchBox.FieldName).setValue(event);
        var searchValue1 = this.form.get(searchBox.FieldName)?.value;
        if (searchValue1) {
          if (this.searchFilterDataTemp == undefined) {
            this.searchFilterDataTemp = new Array<any>();
          }
          this.isDocuware ? this.searchFilterData[searchBox.DisplayAs] = searchValue1 : this.searchFilterDataTemp[searchBox.DisplayAs] = searchValue1;
        } else {
          //delete this.searchFilterDataTemp[searchBox.DisplayAs];
        }
      } else {
        if (searchBox?.DocumentTypeMetadataId == 0) {
          this.form.get(searchBox.FieldName).setValue(event.value);
        }
        else {
          if (this.isDocuware) {
            this.form.get(searchBox.FieldName).setValue(null);
            if (this.searchFilterDataTemp?.length > 0) {
              this.isDocuware ? delete this.searchFilterData[searchBox.DisplayAs] : delete this.searchFilterDataTemp[searchBox.DisplayAs];
            }
            else {
              this.form.get(searchBox.FieldName).setValue(event?.value);
              this.searchFilterData[searchBox.DisplayAs] = this.form.get(searchBox.FieldName)?.value;
            }
          }
        }
      }
    }
  }

  filterAutoCompleteSuggestion(event: any, searchBox) {

    let query = event.query;

    if (query.length >= 2) {
      searchBox.FilteredValues = new Array<any>();

      this.documentCabinetService.GetFilterDataForSearch(searchBox.DocumentTypeMetadataId, query)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: ResultOfT<LabelValueModel[]>) => {
          this.processResult<LabelValueModel[]>(result, () => {
            this.loading = true;
            if (result.IsSuccess) {
              searchBox.FilteredValues = result.ResponseModel;
              this.FilterValues = result.ResponseModel;

              this.loading = false;
            } else {
              this.loading = false;
              this.timeoutFunct(result.Message, false);
            }
          });
        }, (httpResponseError) => {
          this.loading = false;
          this.timeoutFunct(httpResponseError.message, false);
        });

    }
    else {
      searchBox.FilteredValues = new Array<LabelValueModel>();
    }
  }

  filterDropdownSuggestion(searchBox: number, fieldName: string) {

    // searchBox.FilteredValues = new Array<any>();

    this.documentCabinetService.GetFilterData(searchBox)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<LabelValueModel[]>) => {

        this.processResult<LabelValueModel[]>(result, () => {
          this.loading = true;

          if (result.IsSuccess) {

            result.ResponseModel.forEach(
              x => {
                this.optionList.push({ FieldName: fieldName, label: x.label, value: x.value })
              }
            )

            this.loading = false;
          } else {
            this.loading = false;
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.timeoutFunct(httpResponseError.message, false);
      });

  }

  BindDropdown(fieldName: string) {

    var lst: FilterValueModel[] = [];
    lst.push({ FieldName: fieldName, label: "All", value: "" });
    this.optionList.filter(x => x.FieldName == fieldName).forEach(x => {
      lst.push(x);
    });
    return lst;
  }

  filterAutoCompleteSuggestionForSpecialCompanies(event: any, searchBox) {



    let query = event.query;
    if (query.length > 0) {
      // searchBox.SearchFieldValuesFiltered = searchBox.SearchableFieldValues.filter(x => x.FieldValue.toString().toLowerCase().trim().includes(query.toLowerCase().trim()));
      // searchBox.SearchFieldValuesFiltered = searchBox.SearchFieldValuesFiltered.filter((thing, i, arr) => {
      //   return arr.indexOf(arr.find(t => t.FieldValue.toString().toLowerCase().trim() === thing.FieldValue.toString().toLowerCase().trim())) === i;
      // });
      searchBox.SearchFieldValuesFiltered = new Array<SearchableFieldValueResponseModel>();
      this.documentCabinetService.GetFilterDataForSpecialCompanies(searchBox.SearchableFieldId, query)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: ResultOfT<SearchableFieldValueResponseModel[]>) => {
          this.processResult<SearchableFieldValueResponseModel[]>(result, () => {
            this.loading = true;
            if (result.IsSuccess) {
              searchBox.FilteredValues = result.ResponseModel;
              this.FilterValuesForSpecialCompanies = result.ResponseModel;

              this.loading = false;
            } else {
              this.loading = false;
              this.timeoutFunct(result.Message, false);
            }
          });
        }, (httpResponseError) => {
          this.loading = false;
          this.timeoutFunct(httpResponseError.message, false);
        });
    }
    else {
      searchBox.SearchFieldValuesFiltered = new Array<SearchableFieldValueResponseModel>();
    }
  }

  onSearchOLD() {
    this.searchFilterDataTemp = new Array<any>();
    this.displayClearButton = true;
    if (this.isDocuware) {
      var searchValue = this.form.get("FULL_TEXT")?.value;
      if (searchValue) {
        this.searchFilterData['Full Text'] = searchValue;
      }
      const countKeys = Object.keys(this.searchFilterData);
      if (countKeys.length > 0) {
        this.filter();
      } else {
        this.displayClearButton = false;
        this.timeoutFunct('Please select search filter', false);
      }
    }
    else {
      for (let searchBox of this.searchInputList) {
        if (!(searchBox.FieldName === 'FULL_TEXT')) {

          var searchDataItem = {};
          if (searchBox.FieldType === enumFieldTypes.enumInteger || searchBox.FieldType === enumFieldTypes.enumDecimal || searchBox.FieldType === enumFieldTypes.enumCurrency) {
            var searchValueFrom = this.form.get(searchBox.FieldName + 'From')?.value;
            var searchValueTo = this.form.get(searchBox.FieldName + 'To')?.value;
            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValueFrom && searchValueTo) {
                searchDataItem['FieldName'] = searchBox.FieldName;
                searchDataItem['FieldType'] = searchBox.FieldType;
                searchDataItem['FieldValueFrom'] = searchValueFrom;
                searchDataItem['FieldValueTo'] = searchValueTo;
                searchDataItem['DocumentTypeMetadataId'] = searchBox.DocumentTypeMetadataId;

                if (parseFloat(searchValueFrom) > parseFloat(searchValueTo)) {
                  this.timeoutFunct('Please apply appropriate ' + searchBox.FieldName + ' range', false);
                  return;
                }

                this.searchFilterDataTemp.push(searchDataItem);
              }
              else if (searchValueFrom && !searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' To filter', false);
                return;
              }
              else if (!searchValueFrom && searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' From filter', false);
                return;
              }
            }

          }
          else if (searchBox.FieldType === enumFieldTypes.enumDate) {
            var searchValueFrom = this.form.get(searchBox.FieldName + 'From')?.value;
            var searchValueTo = this.form.get(searchBox.FieldName + 'To')?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValueFrom && searchValueTo) {
                searchDataItem['FieldName'] = searchBox.FieldName;
                searchDataItem['FieldType'] = searchBox.FieldType;
                searchDataItem['DocumentTypeMetadataId'] = searchBox.DocumentTypeMetadataId;

                const momentDateValueFrom = moment(searchValueFrom, 'MM/DD/YYYY');
                var dateValueFrom = momentDateValueFrom.format('MM/DD/YYYY');
                searchDataItem['FieldValueFrom'] = dateValueFrom;
                const momentDateValueTo = moment(searchValueTo, 'MM/DD/YYYY');
                var dateValueTo = momentDateValueTo.format('MM/DD/YYYY');
                searchDataItem['FieldValueTo'] = dateValueTo;

                if (dateValueFrom > dateValueTo) {
                  this.timeoutFunct('Please apply appropriate date range', false);
                  return;
                }

                this.searchFilterDataTemp.push(searchDataItem);
              }
              else if (searchValueFrom && !searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' To filter', false);
                return;
              }
              else if (!searchValueFrom && searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' From filter', false);
                return;
              }
            }
          }
          else {
            var searchValue = this.form.get(searchBox.FieldName)?.value?.label ? this.form.get(searchBox.FieldName)?.value?.label : this.form.get(searchBox.FieldName)?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValue) {
                searchDataItem['FieldName'] = searchBox.FieldName;
                searchDataItem['FieldType'] = searchBox.FieldType;
                searchDataItem['FieldValueFrom'] = searchValue;
                searchDataItem['FieldValueTo'] = searchValue;
                searchDataItem['DocumentTypeMetadataId'] = searchBox.DocumentTypeMetadataId;
                this.searchFilterDataTemp.push(searchDataItem);
              }
            }
          }
        }
        else {
          this.fullTextSearch = this.form.get('FULL_TEXT')?.value;
        }
      }
      if (this.searchFilterDataTemp.length > 0 || this.fullTextSearch !== '') {
        this.filterInAppDocs();
      } else {
        this.displayClearButton = false;
        this.timeoutFunct('Please select search filter', false);
      }

    }

  }

  onSearch() {
    this.searchRecords = [];
    this.searchRecordsTemp = [];

    this.displayClearButton = true;
    if (this.isDocuware) {
      var searchValue = this.form.get("FULL_TEXT")?.value;
      if (searchValue) {
        this.searchFilterData['Full Text'] = searchValue;
      }
      const countKeys = Object.keys(this.searchFilterData);
      if (countKeys.length > 0) {

        this.filter();
      } else {
        this.displayClearButton = false;
        this.timeoutFunct('Please select search filter', false);
      }
    }
    else {

      this.metadataSearchModel = new Array<MetadataSearchModel>();
      for (let searchBox of this.searchInputList) {

        if (!(searchBox.FieldName === 'FULL_TEXT')) {

          var searchDataItem = new MetadataSearchModel;
          if (searchBox.FieldType === enumFieldTypes.enumInteger || searchBox.FieldType === enumFieldTypes.enumDecimal || searchBox.FieldType === enumFieldTypes.enumCurrency) {
            var searchValueFrom = this.form.get(searchBox.FieldName + 'From')?.value;
            var searchValueTo = this.form.get(searchBox.FieldName + 'To')?.value;
            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValueFrom && searchValueTo) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.FieldValueFrom = searchValueFrom;
                searchDataItem.FieldValueTo = searchValueTo;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;

                if (parseFloat(searchValueFrom) > parseFloat(searchValueTo)) {
                  this.timeoutFunct('Please apply appropriate ' + searchBox.FieldName + ' range', false);
                  return;
                }

                this.metadataSearchModel.push(searchDataItem);
              }
              else if (searchValueFrom && !searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' To filter', false);
                return;
              }
              else if (!searchValueFrom && searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' From filter', false);
                return;
              }
            }

          }
          else if (searchBox.FieldType === enumFieldTypes.enumDate) {

            var searchValueFrom = this.form.get(searchBox.FieldName + 'From')?.value;
            var searchValueTo = this.form.get(searchBox.FieldName + 'To')?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValueFrom && searchValueTo) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;

                const momentDateValueFrom = moment(searchValueFrom, 'MM/DD/YYYY');
                var dateValueFrom = momentDateValueFrom.format('MM/DD/YYYY');
                searchDataItem.FieldValueFrom = dateValueFrom;
                const momentDateValueTo = moment(searchValueTo, 'MM/DD/YYYY');
                var dateValueTo = momentDateValueTo.format('MM/DD/YYYY');
                searchDataItem.FieldValueTo = dateValueTo;
                if (momentDateValueFrom > momentDateValueTo) {
                  this.timeoutFunct('Please apply appropriate date range', false);
                  return;
                }

                this.metadataSearchModel.push(searchDataItem);
              }
              else if (searchValueFrom && !searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' To filter', false);
                return;
              }
              else if (!searchValueFrom && searchValueTo) {
                this.timeoutFunct('Please apply ' + searchBox.FieldName + ' From filter', false);
                return;
              }
            }
          }
          else {

            var searchValue = this.form.get(searchBox.FieldName)?.value?.label ? this.form.get(searchBox.FieldName)?.value?.label : this.form.get(searchBox.FieldName)?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValue) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.FieldValueFrom = searchValue;
                searchDataItem.FieldValueTo = searchValue;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;
                this.metadataSearchModel.push(searchDataItem);
              }
            }
          }
        }
        else {
          this.fullTextSearch = this.form.get('FULL_TEXT')?.value;
        }

      }
      if (this.metadataSearchModel.length > 0 || (this.fullTextSearch !== '' && this.fullTextSearch != null && this.fullTextSearch != undefined)) {
        this.filterInAppDocs();
      } else {
        this.displayClearButton = false;
        this.timeoutFunct('Please select search filter', false);
      }

    }

  }

  recFunct(recordList: DocuwareRecordsModel[], searchFieldName: string, searchValue: string) {
    var searchedRecords = new Array<DocuwareRecordsModel>();

    if (recordList?.length > 0) {

      recordList.forEach(record => {

        var result = record.DocuwareFields.filter(x => x.FieldName == searchFieldName && x.FieldValue.includes(searchValue));
        if (result.length !== 0) {
          searchedRecords.push(record);
        }

      });
    }
    return searchedRecords;
  }


  onReset() {
    this.form.reset();
    this.searchFilterData = {};
    this.displayClearButton = false;
    this.displayPagination = false;
    this.isInitialEmptyState = true;

    if (this.isDocuware) {
      this.searchRecords = null;
      this.searchRecordsTemp = null;
    } else {
      this.searchRecords = this.backupRecords;
      this.searchRecordsTemp = this.backupRecords;
    }

  }

  onDownload(record: any) {


    this.cabinetRequestModel.DocuwareDocumentId = record.DocumentId.toString();

    this.docuwareCabinetService.generateDocumentViewerLink(this.cabinetRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<string>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {

              this.documentViewerLink = result.ResponseModel;
              window.open(this.documentViewerLink, "_blank");

            }
          }
          else {
            this.loading = false;

            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;

        this.timeoutFunct(httpResponseError.message, false);
      });

  }

  onView(id) {

    var foundDoc = this.searchRecords?.find(x => x.DocumentTypeInboxId === id);
    this.documentTypeInboxId = foundDoc.DocumentTypeInboxId;
    this.filePath = foundDoc?.DynamicFields.DocumentPath;
    this.documentTypeInboxId = id;
    if (foundDoc !== undefined) {
      this.DocumentViewerPopup = true;
      this.viewerLoader = true;
      this.isImage = false;
      this.isPdf = false;
      this.isOfficeDoc = false;
      this.isNutrientViewer = false;

      const fileName = foundDoc?.DynamicFields.DocumentPath.split('\\').pop().split('/').pop();
      this.fileExtension = fileName.split('.').pop().toLowerCase();

      this.fileName = foundDoc?.DynamicFields.ActualDocumentName;
      this.documentTypeDocumentId = foundDoc?.DocumentTypeInboxId;

      // const reqModel = new DownloadFile();
      const reqModel = new DownloadFile();
      reqModel.StrFileName = fileName;
      reqModel.StrCompanyId = this.companyResponseModel?.CompanyId.toString();
      reqModel.StrDocumentTypeId = this.documentTypeResponseModel?.DocumentTypeId.toString();
      reqModel.DownloadFromInbox = true;
      this.cdr.detectChanges();

      this.documentCabinetService.NewGetBase64ForViewerFromAzure(reqModel)
        .pipe(
          takeUntil(this.unsubscriber),
          finalize(() => this.loading = false)
        )
        .subscribe({
          next: async (blob: Blob) => {
            const ext = this.fileExtension.toLowerCase();

            if (['pdf', '.pdf'].includes(ext)) {
              try {
                this.isNutrientViewer = true;
                this.cdr.detectChanges();
                this.loadPdfWithNutrient(blob);
                this.isPdf = true;
                this.viewerLoader = false;
              } catch (error) {
                console.error('Nutrient SDK failed, falling back to iframe:', error);
                const url = URL.createObjectURL(blob);
                this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                this.isPdf = true;
                this.isNutrientViewer = false;
                this.viewerLoader = false;
              }
              return;
            }

            if (this.isOfficeDocument(ext)) {
              try {
                this.isOfficeDoc = true;
                this.isNutrientViewer = true;
                this.cdr.detectChanges();
                this.loadOfficeDocumentWithNutrient(blob);
                this.viewerLoader = false;
              } catch (error) {
                console.error('Nutrient SDK failed for office document:', error);
                const url = URL.createObjectURL(blob);
                this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                this.isOfficeDoc = false;
                this.isNutrientViewer = false;
                this.viewerLoader = false;
                this.timeoutFunct("Office document preview not supported in this browser", false);
              }
              return;
            }

            const reader = new FileReader();
            reader.onloadend = async () => {
              try {
                const base64 = reader.result as string;

                switch (ext) {
                  case '.png':
                  case 'png':
                    // Use Nutrient viewer for PNG images
                    try {
                      this.isNutrientViewer = true;
                      this.cdr.detectChanges();
                      // Small delay to ensure DOM and CSS are ready
                      await new Promise(resolve => setTimeout(resolve, 100));
                      await this.loadPdfWithNutrient(blob);
                      this.viewerLoader = false;
                    } catch (error) {
                      console.error('Nutrient SDK failed for PNG, falling back to image display:', error);
                      this.base64String = 'data:image/png;base64,' + base64.split(',')[1];
                      this.isImage = true;
                      this.isNutrientViewer = false;
                      this.viewerLoader = false;
                    }
                    break;

                  case 'jpg':
                  case '.jpg':
                  case 'jpeg':
                  case '.jpeg':
                    // Use Nutrient viewer for JPEG images
                    try {
                      this.isNutrientViewer = true;
                      this.cdr.detectChanges();
                      // Small delay to ensure DOM and CSS are ready
                      await new Promise(resolve => setTimeout(resolve, 100));
                      await this.loadPdfWithNutrient(blob);
                      this.viewerLoader = false;
                    } catch (error) {
                      console.error('Nutrient SDK failed for JPEG, falling back to image display:', error);
                      this.base64String = 'data:image/jpeg;base64,' + base64.split(',')[1];
                      this.isImage = true;
                      this.isNutrientViewer = false;
                      this.viewerLoader = false;
                    }
                    break;

                  case '.tiff':
                  case 'tiff':
                  case '.tif':
                  case 'tif':
                    try {
                      const binaryData = atob(base64.split(',')[1]);
                      const tiff = new Tiff({ buffer: Uint8Array.from(binaryData, c => c.charCodeAt(0)) });
                      const canvas = tiff.toCanvas();
                      const tiffBase64 = canvas.toDataURL("image/jpeg").replace(/^data:image\/jpeg;base64,/, "");

                      // Convert TIFF to JPEG blob for Nutrient viewer
                      const tiffBlob = await this.dataURLToBlob(`data:image/jpeg;base64,${tiffBase64}`);

                      // Try Nutrient viewer first
                      try {
                        this.isNutrientViewer = true;
                        this.cdr.detectChanges();
                        // Small delay to ensure DOM and CSS are ready
                        await new Promise(resolve => setTimeout(resolve, 100));
                        await this.loadPdfWithNutrient(tiffBlob);
                        this.viewerLoader = false;
                      } catch (nutrientError) {
                        console.error('Nutrient SDK failed for TIFF, falling back to image display:', nutrientError);
                        this.base64String = `data:image/jpeg;base64,${tiffBase64}`;
                        this.isImage = true;
                        this.isNutrientViewer = false;
                        this.viewerLoader = false;
                      }
                    } catch (tiffError) {
                      console.error('TIFF processing failed:', tiffError);
                      this.viewerLoader = false;
                      this.timeoutFunct("TIFF format not supported", false);
                      return;
                    }
                    break;

                  case 'txt':
                  case '.txt':
                    try {
                      const base64Data = base64.split(',')[1];

                      // Proper UTF-8 decoding
                      const byteChars = atob(base64Data);
                      const byteArray = new Uint8Array(
                        [...byteChars].map(c => c.charCodeAt(0))
                      );
                      const textContent = new TextDecoder().decode(byteArray);

                      const canvas = document.createElement('canvas');
                      const ctx = canvas.getContext('2d');
                      if (!ctx) throw new Error('Canvas context not available');

                      const padding = 20;
                      const lineHeight = 20;
                      const maxWidth = 760;

                      ctx.font = '14px Courier New, monospace';

                      // Wrap text first
                      const lines = [];
                      textContent.split('\n').forEach(line => {
                        let current = '';
                        line.split(' ').forEach(word => {
                          const test = current + word + ' ';
                          if (ctx.measureText(test).width > maxWidth && current) {
                            lines.push(current);
                            current = word + ' ';
                          } else {
                            current = test;
                          }
                        });
                        lines.push(current);
                      });

                      // Set canvas size AFTER wrapping - limit maximum size
                      canvas.width = 800;
                      canvas.height = Math.min(Math.max(600, lines.length * lineHeight + padding * 2), 4000);

                      // Validate canvas dimensions
                      if (canvas.width <= 0 || canvas.height <= 0) {
                        throw new Error('Invalid canvas dimensions');
                      }

                      // Background
                      ctx.fillStyle = '#fff';
                      ctx.fillRect(0, 0, canvas.width, canvas.height);

                      // Text
                      ctx.fillStyle = '#000';
                      ctx.font = '14px Courier New, monospace';

                      let y = padding + 16; // Add baseline offset
                      lines.forEach((line, index) => {
                        if (y < canvas.height - padding) { // Ensure we don't draw beyond canvas
                          ctx.fillText(line.trim(), padding, y);
                          y += lineHeight;
                        }
                      });

                      // Robust blob conversion with fallback
                      let blob: Blob;
                      try {
                        // First attempt: standard toBlob
                        blob = await new Promise<Blob>((resolve, reject) => {
                          const timeout = setTimeout(() => reject(new Error('toBlob timeout')), 5000);
                          canvas.toBlob((b) => {
                            clearTimeout(timeout);
                            if (b) resolve(b);
                            else reject(new Error('Canvas toBlob returned null'));
                          }, 'image/png', 0.8);
                        });
                      } catch (blobError) {
                        console.warn('toBlob failed, using dataURL fallback:', blobError);
                        // Fallback: convert via dataURL
                        try {
                          const dataURL = canvas.toDataURL('image/png', 0.8);
                          if (!dataURL || dataURL === 'data:,') {
                            throw new Error('Canvas dataURL failed');
                          }
                          blob = await this.dataURLToBlob(dataURL);
                        } catch (dataUrlError) {
                          throw new Error(`Both canvas conversion methods failed: ${blobError.message}, ${dataUrlError.message}`);
                        }
                      }

                      // Check if component is still alive before proceeding
                      if (this.unsubscriber.closed) {
                        console.warn('Component destroyed during TXT rendering, aborting');
                        return;
                      }

                      this.isNutrientViewer = true;

                      // Safe detectChanges call
                      try {
                        this.cdr.detectChanges();
                      } catch (cdError) {
                        console.warn('DetectChanges failed during TXT rendering:', cdError);
                        return;
                      }

                      await this.loadPdfWithNutrient(blob);
                      this.viewerLoader = false;

                    } catch (error) {
                      console.error('TXT render failed:', error);
                      this.viewerLoader = false;
                      this.timeoutFunct("Text format not supported", false);
                    }
                    break;

                  case '.json':
                  case 'json':
                    // Convert JSON to formatted image for Nutrient viewer
                    try {
                      const jsonContent = atob(base64.split(',')[1]);
                      let formattedJson: string;
                      try {
                        const parsedJson = JSON.parse(jsonContent);
                        formattedJson = JSON.stringify(parsedJson, null, 2);
                      } catch (parseError) {
                        formattedJson = jsonContent;
                      }

                      // Create canvas for rendering JSON
                      const canvas = document.createElement('canvas');
                      const ctx = canvas.getContext('2d');
                      if (!ctx) throw new Error('Canvas context not available');

                      // Set canvas size based on content - limit maximum size
                      canvas.width = 900;
                      const lines = formattedJson.split('\n');
                      canvas.height = Math.min(Math.max(600, lines.length * 18 + 40), 4000);

                      // Validate canvas dimensions
                      if (canvas.width <= 0 || canvas.height <= 0) {
                        throw new Error('Invalid canvas dimensions');
                      }

                      // Set background and text style
                      ctx.fillStyle = '#ffffff';
                      ctx.fillRect(0, 0, canvas.width, canvas.height);
                      ctx.fillStyle = '#000000';
                      ctx.font = '13px Courier New, monospace';

                      // Draw JSON content line by line with boundary checking
                      let y = 25;
                      lines.forEach(line => {
                        // Handle long lines by wrapping
                        const maxWidth = canvas.width - 40;
                        if (y < canvas.height - 20 && ctx.measureText(line).width > maxWidth) {
                          // Split long lines
                          let remaining = line;
                          while (remaining.length > 0 && y < canvas.height - 20) {
                            let splitIndex = remaining.length;
                            while (ctx.measureText(remaining.substring(0, splitIndex)).width > maxWidth && splitIndex > 0) {
                              splitIndex--;
                            }
                            ctx.fillText(remaining.substring(0, splitIndex), 20, y);
                            remaining = remaining.substring(splitIndex);
                            y += 18;
                          }
                        } else if (y < canvas.height - 20) {
                          ctx.fillText(line, 20, y);
                          y += 18;
                        }
                      });

                      // Robust blob conversion with fallback
                      let blob: Blob;
                      try {
                        // First attempt: standard toBlob
                        blob = await new Promise<Blob>((resolve, reject) => {
                          const timeout = setTimeout(() => reject(new Error('toBlob timeout')), 5000);
                          canvas.toBlob((b) => {
                            clearTimeout(timeout);
                            if (b) resolve(b);
                            else reject(new Error('Canvas toBlob returned null'));
                          }, 'image/png', 0.8);
                        });
                      } catch (blobError) {
                        console.warn('JSON toBlob failed, using dataURL fallback:', blobError);
                        // Fallback: convert via dataURL
                        try {
                          const dataURL = canvas.toDataURL('image/png', 0.8);
                          if (!dataURL || dataURL === 'data:,') {
                            throw new Error('Canvas dataURL failed');
                          }
                          blob = await this.dataURLToBlob(dataURL);
                        } catch (dataUrlError) {
                          throw new Error(`Both canvas conversion methods failed: ${blobError.message}, ${dataUrlError.message}`);
                        }
                      }

                      // Check if component is still alive before proceeding
                      if (this.unsubscriber.closed) {
                        console.warn('Component destroyed during JSON rendering, aborting');
                        return;
                      }

                      this.isNutrientViewer = true;

                      // Safe detectChanges call
                      try {
                        this.cdr.detectChanges();
                      } catch (cdError) {
                        console.warn('DetectChanges failed during JSON rendering:', cdError);
                        return;
                      }

                      // Small delay to ensure DOM and CSS are ready
                      await new Promise(resolve => setTimeout(resolve, 100));
                      await this.loadPdfWithNutrient(blob);
                      this.viewerLoader = false;

                    } catch (error) {
                      console.error('JSON render failed:', error);
                      this.viewerLoader = false;
                      this.timeoutFunct("JSON format not supported", false);
                    }
                    break;

                  default:
                    // Unsupported format
                    this.viewerLoader = false;
                    this.timeoutFunct(`Unsupported file format: ${ext}`, false);
                    return;
                }

              } catch (error) {
                this.viewerLoader = false;
                this.timeoutFunct("Error processing file", false);
              }
            };

            reader.readAsDataURL(blob);
          },
          error: (error) => {
            this.viewerLoader = false;
            this.timeoutFunct(error.message, false);
          }
        });
    }
  }

  isOfficeDocument(extension: string): boolean {
    const officeExtensions = [
      'doc', '.doc', 'docx', '.docx', 'dotx', '.dotx', 'docm', '.docm',
      'xls', '.xls', 'xlsx', '.xlsx', 'xlsm', '.xlsm',
      'ppt', '.ppt', 'pptx', '.pptx', 'pptm', '.pptm'
    ];
    return officeExtensions.includes(extension.toLowerCase());
  }

  private async dataURLToBlob(dataURL: string): Promise<Blob> {
    const response = await fetch(dataURL);
    return response.blob();
  }

  loadOfficeDocumentWithNutrient(blob: Blob): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        // Wait for the container to be ready
        const container = await this.waitForNutrientContainer();

        // Ensure container has proper dimensions
        this.ensureContainerDimensions(container);

        try {
          await NutrientViewer.unload(container);
        } catch (error) {
          // Container wasn't loaded, continue
        }

        const arrayBuffer = await blob.arrayBuffer();
        const configuration = {
          container: container,
          document: arrayBuffer,
          enableAnnotations: true,
          enableDownload: false,
          enablePrint: true,
          readOnly: false,
          enableContentEditing: true,
          toolbarItems: [
            ...NutrientViewer.defaultToolbarItems.filter((item: any) => item.type !== ''),
            { type: "content-editor", dropdownGroup: "editor" },
            {
              type: "custom",
              title: 'Save',
              onPress: () => {
                this.viewerLoader = true;
                this.cdr.detectChanges();
                this.onExportDocument();
              }
            }
          ]
        };

        const result = await NutrientViewer.load(configuration);
        this.nutrientInstance = result;

        this.nutrientInstance.addEventListener('viewState.change', async (viewState) => {
          if (!viewState.isEditing && this.hasContentChanges) {
            setTimeout(async () => {
              this.viewerLoader = true;
              await this.onExportDocument();
              this.hasContentChanges = false;
            }, 300);
          }
        });

        this.nutrientInstance.addEventListener('search.stateChange', (searchState) => {
          this.searchResults = searchState.results || [];
        });


        if (this.fullTextSearch) {
          try {
            if (this.nutrientInstance.startUISearch) {
              this.nutrientInstance.startUISearch(this.fullTextSearch);
            } else {
              const currentSearchState = this.nutrientInstance.searchState || new NutrientViewer.SearchState({
                term: '',
                results: NutrientViewer.Immutable.List([]),
                focusedResultIndex: 0,
                isFocused: false,
                isLoading: false
              });

              const newSearchState = currentSearchState.set('term', this.fullTextSearch);
              this.nutrientInstance.setSearchState(newSearchState);

              this.performSearch(this.fullTextSearch);
            }
          } catch (error) {
            this.performSearch(this.fullTextSearch);
          }
        }
        resolve();
      } catch (error) {
        console.error('Nutrient SDK error for office document:', error);
        reject(error);
      }
    });
  }

  hasContentChanges: boolean = false;
  isContentEditorEnabled: boolean = false;
  originalDocumentContent: ArrayBuffer | null = null;
  showUnsavedChangesDialog: boolean = false;
  currentSearchTerm: string = '';
  searchResults: any[] = [];

  loadPdfWithNutrient(blob: Blob): Promise<void> {

    return new Promise(async (resolve, reject) => {
      try {
        // Wait for the container to be ready
        const container = await this.waitForNutrientContainer();
        console.log(container, 'Nutrient Viewer Container');

        // Ensure container has proper dimensions
        this.ensureContainerDimensions(container);

        try {
          await NutrientViewer.unload(container);
        } catch (error) {
          console.log('Container was not loaded, proceeding with load');
        }

        container.innerHTML = '';
        const arrayBuffer = await blob.arrayBuffer();

        this.originalDocumentContent = arrayBuffer.slice(0);
        this.isContentEditorEnabled = true;
        this.hasContentChanges = false;
        this.currentSearchTerm = this.fullTextSearch || '';

        const configuration = {
          container: container,
          document: arrayBuffer,
          enableAnnotations: true,
          enableDownload: false,
          enablePrint: true,
          readOnly: false,
          enableContentEditing: true,
          toolbarItems: [
            ...NutrientViewer.defaultToolbarItems.filter((item: any) => item.type !== ''),
            { type: "content-editor", dropdownGroup: "editor" },
            {
              type: "custom",
              title: 'Save',
              onPress: () => {
                this.viewerLoader = true;
                this.cdr.detectChanges();
                this.onExportDocument();
              }
            }
          ]
        };
        const result = await NutrientViewer.load(configuration);
        this.nutrientInstance = result;
        console.log(this.nutrientInstance, 'Nutrient Viewer Instance');

        this.nutrientInstance.addEventListener('viewState.change', async (viewState) => {
          if (!viewState.isEditing && this.hasContentChanges) {
            setTimeout(async () => {
              this.viewerLoader = true;
              await this.onExportDocument();
              this.hasContentChanges = false;
            }, 300);
          }
        });

        if (this.nutrientInstance.addEventListener) {
          this.nutrientInstance.addEventListener('search.stateChange', (searchState) => {
            this.searchResults = searchState.results || [];
          });
        }

        if (this.fullTextSearch) {
          try {
            if (this.nutrientInstance.startUISearch) {
              this.nutrientInstance.startUISearch(this.fullTextSearch);
            } else {
              const currentSearchState = this.nutrientInstance.searchState || new NutrientViewer.SearchState({
                term: '',
                results: NutrientViewer.Immutable.List([]),
                focusedResultIndex: 0,
                isFocused: false,
                isLoading: false
              });

              const newSearchState = currentSearchState.set('term', this.fullTextSearch);
              this.nutrientInstance.setSearchState(newSearchState);

              this.performSearch(this.fullTextSearch);
            }
          } catch (error) {
            this.performSearch(this.fullTextSearch);
          }
        }

        this.setupContentChangeListeners();
        resolve();
      } catch (error) {
        console.error('Nutrient SDK error:', error);
        reject(error);
      }
    });
  }

  async onExportDocument() {
    if (!this.nutrientInstance) {
      this.timeoutFunct('No document loaded for export', false);
      return;
    }

    try {
      this.loading = true;
      const exportedDocument = await this.nutrientInstance.exportPDF();
      const file = new File([exportedDocument], this.fileName || 'exported-document.pdf', {
        type: 'application/pdf'
      });
      await this.bulkUploadUpdatedDocument([file]);

    } catch (error) {
      this.loading = false;
      console.error('Export failed:', error);
      this.timeoutFunct('Failed to export document', false);
    }
  }

  bulkConst: number = 10;
  isUploading: boolean = false;
  failedFileNames: string[] = [];
  uploadedBatches: number = 0;
  failedBatches: number = 0;
  totalIterations: number = 0;
  iteration: number = 0;
  ForInbox: boolean = true;

  async bulkUploadUpdatedDocument(files: File[]) {
    if (!files || files.length === 0) {
      this.loading = false;
      this.viewerLoader = false;
      this.timeoutFunct('No files to upload', false);
      return;
    }

    if (!this.documentTypeDocumentId) {
      this.loading = false;
      this.viewerLoader = false;
      this.timeoutFunct('No document type selected', false);
      return;
    }

    try {
      this.isUploading = true;
      this.loading = true;

      const totalFiles = files.length;
      this.totalIterations = Math.ceil(totalFiles / this.bulkConst);
      const remainder = totalFiles % this.bulkConst;
      this.iteration = 0;
      this.uploadedBatches = 0;
      this.failedBatches = 0;
      this.failedFileNames = [];

      await this.processUploadBatch(files, this.iteration, totalFiles, remainder);

    } catch (error) {
      this.isUploading = false;
      this.loading = false;
      this.viewerLoader = false;
      console.error('Bulk upload failed:', error);
      this.timeoutFunct('Upload failed: ' + error.message, false);
    }
  }

  private async processUploadBatch(files: File[], iteration: number, totalFiles: number, remainder: number): Promise<void> {
    const formData = new FormData();
    formData.append('UserId', this.userId.toString());
    formData.append('CompanyId', this.companyId.toString());
    formData.append('DocumentTypeId', this.documentTypeResponseModel?.DocumentTypeId.toString());
    formData.append('DocumentCabinetId', this.documentTypeResponseModel.DocumentCabinetId?.toString() ?? '0');
    formData.append('DocumentTypeInboxId', this.documentTypeInboxId?.toString() ?? '0');
    formData.append('ForInbox', this.ForInbox.toString());
    formData.append('IsMapped', this.isMapped.toString());
    const startIndex = iteration * this.bulkConst;
    let endIndex = this.bulkConst - 1;
    if (iteration === (this.totalIterations - 1)) {
      if (remainder !== 0) {
        endIndex = remainder - 1;
      }
    }
    const batchFiles: File[] = [];
    let currentFileIndex = startIndex;
    for (let i = 0; i <= endIndex; i++) {
      if (currentFileIndex < files.length) {
        batchFiles.push(files[currentFileIndex]);
        formData.append('PostedFiles', files[currentFileIndex]);
        currentFileIndex++;
      }
    }

    try {
      const result = await this.documentCabinetService.UpdatePdfInAzure(formData).toPromise();
      if (result?.IsSuccess) {
        this.uploadedBatches += batchFiles.length;
        if (iteration === (this.totalIterations - 1)) {
          this.handleUploadComplete();
        } else {
          this.iteration++;
          await this.processUploadBatch(files, this.iteration, totalFiles, remainder);
        }
      } else {
        this.failedBatches += batchFiles.length;
        this.failedFileNames.push(...batchFiles.map(f => f.name));

        if (iteration === (this.totalIterations - 1)) {
          this.handleUploadComplete();
        } else {
          this.iteration++;
          await this.processUploadBatch(files, this.iteration, totalFiles, remainder);
        }
      }
    } catch (error) {
      this.failedBatches += batchFiles.length;
      this.failedFileNames.push(...batchFiles.map(f => f.name));

      if (iteration === (this.totalIterations - 1)) {
        this.handleUploadComplete();
      } else {
        this.iteration++;
        await this.processUploadBatch(files, this.iteration, totalFiles, remainder);
      }
    }
  }

  handleUploadComplete() {
    this.isUploading = false;
    this.loading = false;
    this.viewerLoader = false;

    if (this.failedBatches > 0 && this.uploadedBatches > 0) {
      this.timeoutFunct(`${this.uploadedBatches} files uploaded successfully, ${this.failedBatches} files failed`, false);
    } else if (this.uploadedBatches > 0 && this.failedBatches === 0) {
      this.timeoutFunct('Document updated successfully', true);
      this.cdr.detectChanges();

      // this.refreshCurrentSearch();
      this.hasContentChanges = false;

      // this.viewerLoader = false;
      // this.reloadPdfViewer();
    } else {
      this.timeoutFunct('Upload failed for all files', false);
    }
    if (this.failedBatches > 0 && this.uploadedBatches === 0) {
      setTimeout(() => {
        this.onCloseDocumentViewer();
      }, environment.messageLifeSpan);
    }
  }

  performSearch(searchTerm: string): void {
    if (!this.nutrientInstance || !searchTerm) {
      return;
    }

    try {
      this.nutrientInstance.search(searchTerm);
      this.currentSearchTerm = searchTerm;

    } catch (error) {
      console.error('Error performing search:', error);
      this.timeoutFunct('Error performing search in document', false);
    }
  }

  setupContentChangeListeners(): void {
    if (!this.nutrientInstance) return;

    try {
      this.nutrientInstance.addEventListener('document.change', () => {
        this.hasContentChanges = true;
      });

      this.nutrientInstance.addEventListener('formFieldValues.update', () => {
        this.hasContentChanges = true;
      });

      this.nutrientInstance.addEventListener('formFields.change', () => {
        this.hasContentChanges = true;
      });

      setTimeout(() => {
        if (this.nutrientViewerElement?.nativeElement) {
          const container = this.nutrientViewerElement.nativeElement;
          container.addEventListener('keydown', (event) => {
            if (event.key === 'Backspace' || event.key === 'Delete' ||
              event.key === 'Enter' || event.key === 'Tab' ||
              (event.key.length === 1 && !event.ctrlKey && !event.altKey)) {
              setTimeout(() => {
                this.hasContentChanges = true;
              }, 100);
            }
          });
          container.addEventListener('input', () => {
            this.hasContentChanges = true;
          });

          container.addEventListener('paste', () => {
            setTimeout(() => {
              this.hasContentChanges = true;
            }, 100);
          });
        }
      }, 1000);

    } catch (error) {
      console.warn('Could not set up content change listeners:', error);
      setTimeout(() => {
        if (this.nutrientViewerElement?.nativeElement) {
          this.nutrientViewerElement.nativeElement.addEventListener('click', () => {
            setTimeout(() => {
              this.hasContentChanges = true;
            }, 1000);
          });
        }
      }, 500);
    }
  }

  transformImg() {
    if (this.base64String != '') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.base64String);
    }
  }

  onCloseDocumentViewer() {
    this.DocumentViewerPopup = false;
    this.base64String = '';
    this.isImage = false;
    this.isPdf = false;
    this.viewerLoader = false;
  }

  onFileDownload(id) {

    var foundDoc = this.searchRecords?.find(x => x.DocumentTypeInboxId === id);
    if (foundDoc !== undefined) {
      const fileName = foundDoc?.DynamicFields.DocumentPath.split('\\').pop().split('/').pop();

      const reqModel = new DownloadFile();
      reqModel.StrFileName = fileName;
      reqModel.StrCompanyId = this.companyResponseModel?.CompanyId.toString();
      reqModel.StrDocumentTypeId = this.documentTypeResponseModel?.DocumentTypeId.toString();
      reqModel.DownloadFromInbox = true;
      reqModel.UserId = this.userId;
      reqModel.StrDocumentTypeInboxId = id.toString();
      reqModel.isPrint = false;

      this.documentCabinetService.DownloadFileNew(reqModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: any) => {
          this.processResult<any>(result, () => {

            if (result) {
              importedSaveAs(result, this.fileName);
            } else {
              this.timeoutFunct(result.Message, false);
            }
          });
        }, (httpResponseError) => {
          this.timeoutFunct(httpResponseError.message, false);
        });
    }
  }

  onPdfDownload(id) {

    var foundDoc = this.searchRecords?.find(x => x.DocumentTypeInboxId === id);
    if (foundDoc !== undefined) {
      const fileName = foundDoc?.DynamicFields.DocumentPath.split('\\').pop().split('/').pop();

      const reqModel = new DownloadFile();
      reqModel.StrFileName = fileName;
      reqModel.StrCompanyId = this.companyResponseModel?.CompanyId.toString();
      reqModel.StrDocumentTypeId = this.documentTypeResponseModel?.DocumentTypeId.toString();
      reqModel.DownloadFromInbox = true;
      reqModel.UserId = this.userId;
      reqModel.StrDocumentTypeInboxId = id.toString();
      reqModel.isPrint = true;


      this.documentCabinetService.DownloadFileNew(reqModel)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: any) => {
          this.processResult<any>(result, () => {

            if (result) {

              // importedSaveAs(result, this.fileName);
              var file = new Blob([result], { type: 'application/pdf' });
              const blobURL = URL.createObjectURL(file);
              // window.open(blobURL, '_blank');
              var iframe = document.createElement('iframe'); //load content in an iframe to print later
              document.body.appendChild(iframe);

              iframe.style.display = 'none';
              iframe.src = blobURL;
              // iframe.focus();
              // iframe.contentWindow.print();

              iframe.onload = function () {
                setTimeout(function () {
                  iframe.focus();
                  iframe.contentWindow.print();
                }, 500);
              };

            } else {
              this.timeoutFunct(result.Message, false);
            }
          });
        }, (httpResponseError) => {
          this.timeoutFunct(httpResponseError.message, false);
        });
    }
  }

  customSort(event: SortEvent) {
    // event.data.sort((data1, data2) => {
    //   let value1 = data1[event.field];
    //   let value2 = data2[event.field];
    //   let result = null;

    //   if (value1 == null && value2 != null)
    //     result = -1;
    //   else if (value1 != null && value2 == null)
    //     result = 1;
    //   else if (value1 == null && value2 == null)
    //     result = 0;
    //   else if (typeof value1 === 'string' && typeof value2 === 'string')
    //     result = value1.localeCompare(value2);
    //   else
    //     result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

    //   return (event.order * result);
    // });


    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (value1 != null && value2 != null) {
        if (event.field.toLocaleLowerCase().includes('date')) {
          var datevalue1 = moment(value1, 'MM/DD/YYYY').format('YYYY/MM/DD');
          var datevalue2 = moment(value2, 'MM/DD/YYYY').format('YYYY/MM/DD');

          result = (datevalue1 <= datevalue2) ? -1 : (datevalue1 > datevalue2) ? 1 : 0;
        }

        // else if (event.field.toLocaleLowerCase() === 'currency' || event.field.toLocaleLowerCase() === 'decimal' || event.field.toLocaleLowerCase() === 'integer') {
        else if (!value1.match(/[a-z]/i) && !value2.match(/[a-z]/i)) {
          var floatvalue1 = parseFloat(value1);
          var floatvalue2 = parseFloat(value2);

          result = (floatvalue1 <= floatvalue2) ? -1 : (floatvalue1 > floatvalue2) ? 1 : 0;
        }

        else
          result = value1.localeCompare(value2);
      }
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });


  }

  onDocumentTypeChange() {
    this.selectedDocumentType;
    if (this.selectedDocumentType !== null) {
      this.documentTypeId = this.selectedDocumentType.DocumentTypeId;
      if (this.documentTypeId > 0) {
        this.GetPermissionByUserId();
      }
      var routerUrl = '/custom-webpage/' + this.selectedDocumentType.DocumentTypeURL;
      this.router.navigate([routerUrl], { relativeTo: this.activatedRoute }); // when working with same route but different query params add 'this.router.routeReuseStrategy.shouldReuseRoute = () => false;' in constructor 
    }
  }

  private authenticateCustomPage() {
    this.loading = true;
    this.customLoader = true;
    this.docuwareCabinetService.AuthenticateCustomPageUser(this.forgotPasswordRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<InceptionCustomAuthModel>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {

              this.customAuthResponseModel = result.ResponseModel;
              if (this.customAuthResponseModel?.Company) {
                this.companyResponseModel = this.customAuthResponseModel.Company;
                this.companyId = this.companyResponseModel.CompanyId;
              }

              if (this.customAuthResponseModel?.DocumentType) {
                this.documentTypeResponseModel = this.customAuthResponseModel?.DocumentType;
                this.cardImageBase64 = 'data:image/png;base64,' + this.documentTypeResponseModel.LogoImage;
              }

              if (this.documentTypeResponseModel.LogoImage) {
                this.cardImageBase64 = 'data:image/png;base64,' + this.documentTypeResponseModel.LogoImage;
              }

              this.cabinetRequestModel = new DocuwareCabinetReuestModel();
              this.cabinetRequestModel.DocumentTypeId = this.customAuthResponseModel?.DocumentType?.DocumentTypeId;
              this.cabinetRequestModel.CabinetId = this.customAuthResponseModel?.DocumentType?.DocuwareCabinetId;
              this.cabinetRequestModel.OrganizationName = this.customAuthResponseModel?.Company?.DocuwareMasters[0]?.OrganizationName;
              this.cabinetRequestModel.ServerURL = this.customAuthResponseModel?.Company?.DocuwareMasters[0]?.ServerURL;
              this.cabinetRequestModel.UserName = this.customAuthResponseModel?.Company?.DocuwareMasters[0]?.UserName;
              this.cabinetRequestModel.Password = this.customAuthResponseModel?.Company?.DocuwareMasters[0]?.Password;
              this.cabinetRequestModel.PassPhrase = this.customAuthResponseModel?.Company?.DocuwareMasters[0]?.PassPhrase;
              this.cabinetRequestModel.PageNo = 1;
              this.cabinetRequestModel.PageSize = this.pageSize;

              if (this.companyResponseModel?.DocuwareMasters?.length > 0 && this.companyResponseModel?.InterfaceWith === enumDatabaseType.enumDocuware) {
                this.isDocuware = true;
                // this.getFileCabinetRecordsById();
                // if(this.cabinetRequestModel.ServerURL !== 'https://nashuanh.docuware.cloud'){
                //   this.getFileCabinetRecordsById();
                // }
                if (this.cabinetRequestModel.CabinetId == 'eb2769dc-2eb7-4e7b-a9d8-a9a49d2f1b38'
                  || this.cabinetRequestModel.CabinetId == '9e1b6b38-2ecc-4c18-b7f5-1a9592c1596e'
                  || this.cabinetRequestModel.CabinetId == '40ed34b0-23b3-4fa3-9df6-acc88589364a') {

                  this.getSearchableFieldsFromDb();
                  this.loading = false;
                  this.customLoader = false;
                }
                else {
                  this.forSepcialCompanyDb = false;
                  this.getSearchControlValues();
                }
              }
              else {
                // methods tp get app database records
                if (this.documentTypeResponseModel) {
                  this.forSepcialCompanyDb = false;
                  this.getAllDocumentTypeDocument();
                  this.getAllDocumentTypeList();
                }
              }

            } else {
              // this.loading = false;
              // this.customLoader = false;
            }
          }
          else {
            // this.loading = false;
            // this.customLoader = false;

            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        // this.loading = false;
        // this.customLoader = false;

        this.timeoutFunct(httpResponseError.message, false);
      });

  }

  getSearchableFieldsFromDb() {
    this.docuwareCabinetService.getSearchableFieldsByCabinetId(this.cabinetRequestModel.CabinetId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<SearchableFieldResponseModel[]>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {

            if (result.ResponseModel) {
              this.searchableFieldModel = result.ResponseModel;
              if (this.searchableFieldModel.length > 0) {
                this.isSearchHasData = true;
                this.displayPagination = false;
                this.forSepcialCompanyDb = true;

                this.showSearchPanel = true;
              }
              else {
                this.isSearchHasData = false;

                this.showSearchPanel = false;
              }
            }
            this.buildForm();
            this.loading = false;
          }
          else {
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.timeoutFunct(httpResponseError.message, false);
      });
  }


  private getAllDocumentTypeDocument() {

    this.loading = true;
    var isCustomPage = true;
    this.documentService.GetRawDataForDynamicObject(this.documentTypeResponseModel.DocumentTypeId, isCustomPage)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<DocumentTypeDocumentModelForSearch>) => {
        this.processResult<DocumentTypeDocumentModelForSearch>(result, () => {
          this.loading = true;
          if (result.IsSuccess) {
            this.searchRecords = [];
            this.backupRecords = [];

            if (result.ResponseModel) {
              if (result.ResponseModel.Documents) {
                this.documents = result.ResponseModel.Documents;
              }
              if (this.documents?.length > 0) {
                this.showSearchPanel = true;
              }

              if (result.ResponseModel.BackupSearchRecords) {
                this.backupRecords = result.ResponseModel.BackupSearchRecords;
                this.searchRecords = result.ResponseModel.BackupSearchRecords;
                this.backupSearchRecords = result.ResponseModel.BackupSearchRecords;
              }

              if (result.ResponseModel.SearchInput) {
                this.searchInputList = new Array<SearchInputModel>();
                this.searchInputList = result.ResponseModel.SearchInput;
                // this.showSearchPanel = true;
              }
            }
            this.buildForm();
            this.prepareMetadetaHeaders();
            //this.performInitialSearch();
            this.loading = false;
          } else {
            this.loading = false;
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.timeoutFunct(httpResponseError.message, false);
      });
  }

  private getAllDocumentTypeList() {
    this.loading = true;
    this.documentService.GetAllDocumentTypesByCabinetId(this.documentTypeResponseModel.DocumentCabinetId)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<DocumentTypesModel[]>) => {
        this.processResult<DocumentTypesModel[]>(result, () => {
          if (result.IsSuccess) {
            this.documentTypeList = result.ResponseModel;

            if (this.documentTypeResponseModel && this.documentTypeList.length > 0) {
              this.selectedDocumentType = new DocumentTypesModel();
              this.selectedDocumentType = this.documentTypeList.find(x => x.DocumentTypeId == this.documentTypeResponseModel.DocumentTypeId);
              // this.showSearchPanel = true;

              this.selectedDocumentTypeList = this.documentTypeList.find(x => x.DocumentTypeId == this.documentTypeResponseModel.DocumentTypeId);
              if (this.selectedDocumentType && !this.isLazyLoadingEnabled) {
                this.performInitialSearch();
              }
            }

            this.searchLoader = false;
            this.customLoader = false;
          } else {
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.timeoutFunct(httpResponseError.message, false);
      });
    this.loading = false;
  }

  private getFileCabinetRecordsById() {

    this.loading = true;
    this.customLoader = true;

    // this.docuwareService.getFileCabinetRecordsById(this.cabinetRequestModel)
    this.docuwareCabinetService.getDocuwareFileCabinetRecords(this.cabinetRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<DocuwareRecordsModel[]>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {

              this.docuwareRecordsModel = result.ResponseModel;
              this.docuwareRecordsBackup = this.docuwareRecordsModel;

              this.headers = [];
              this.records = [];
              this.searchRecords = [];

              this.docuwareRecordsModel.forEach(docuwareRecord => {
                const record = {};

                record["DocumentId"] = docuwareRecord.DocuwareDocumentId;


                docuwareRecord.DocuwareFields.forEach(field => {

                  record[field.DisplayAs] = field.FieldValue;

                });

                this.records.push(record);
              });

              this.searchRecords = this.records;
              this.backupRecords = this.records;

              this.headers.push({ headerName: "DocumentId", fieldType: 'Numeric', sequence: -1 });
              this.headers.push({ headerName: 'View', fieldType: 'Text', sequence: 0 });
              this.docuwareRecordsModel[0]?.DocuwareFields.forEach(field => {
                if (field.IsDisplay) {

                  this.headers.push({ headerName: field.DisplayAs, fieldType: field.FieldType, sequence: field.DisplaySequence });
                }
              });

              this.headers = this.headers.sort((a, b) => a.sequence - b.sequence);

              this.displayPagination = true;

              this.startRecord = ((this.cabinetRequestModel.PageNo - 1) * (this.pageSize)) + 1;
              // this.endRecord = this.startRecord + this.pageSize -1;
              this.endRecord = this.startRecord + this.searchRecords.length - 1;

              if (this.pageCount == this.paginationPage) {
                this.endRecord = this.totalRecordCount;
              }

            }
            this.loading = false;
            this.customLoader = false;
            // this.buildForm();
          }
          else {
            this.loading = false;
            this.customLoader = false;

            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.customLoader = false;

        this.timeoutFunct(httpResponseError.message, false);
      });
  }


  changePage(pageNumber: string) {

    // this.cabinetRequestModel.PageNo = pageNumber;
    pageNumber;

    this.paginationPage = parseInt($('.cdp').attr('actpage'), 10);

    if (pageNumber === '+1') {
      this.paginationPage++;
    } else if (pageNumber === '-1') {
      this.paginationPage--;
    } else {
      this.paginationPage = parseInt(pageNumber, 10);
    }
    $('.cdp').attr('actpage', this.paginationPage);


    this.cabinetRequestModel.PageNo = this.paginationPage;
    this.getFileCabinetRecordsById();
  }

  private getSearchControlValues() {
    this.loading = true;
    this.customLoader = true;

    this.docuwareCabinetService.getSearchControlValue(this.cabinetRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result: ResultOfT<DocuwareRecordsModel[]>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {

              this.docuwareSearchControlModel = result.ResponseModel;
              if (this.docuwareSearchControlModel.length > 0) {

                this.showSearchPanel = true;
                this.totalRecordCount = this.docuwareSearchControlModel[0].TotalRecordCount;
                this.pageCount = Math.ceil(this.totalRecordCount / this.pageSize);

                this.pageArray = new Array<number>();
                this.pageArray = Array(this.pageCount);
              }

              var searchControls = [];

              this.docuwareSearchControlModel.forEach(docuwareRecord => {
                const record = {};

                record["DocumentId"] = docuwareRecord.DocuwareDocumentId;


                docuwareRecord.DocuwareFields.forEach(field => {

                  record[field.DisplayAs] = field.FieldValue;

                });

                searchControls.push(record);
              });


              const searchModel = this.docuwareSearchControlModel[0]?.DocuwareFields.filter(x => x.IsSearch == true);
              this.searchInputList = new Array<SearchInputModel>();
              var forFulltext = new SearchInputModel();

              forFulltext.DisplayAs = 'Full Text';
              forFulltext.FieldName = 'FULL_TEXT';
              forFulltext.FieldType = 'Text';
              forFulltext.Sequence = 0;

              this.searchInputList.push(forFulltext);
              if (searchModel?.length > 0) {

                searchModel.forEach(item => {
                  var searchInput = new SearchInputModel();
                  searchInput.DisplayAs = item.DisplayAs;
                  searchInput.FieldName = item.FieldName;
                  searchInput.FieldType = item.FieldType;
                  searchInput.Sequence = item.SearchSequence;

                  this.searchInputList.push(searchInput);

                });
              }

              this.searchInputList.forEach(item => {
                item.Values = new Array<{ label: '', value: '' }>();

                if (item.DisplayAs !== "Full Text") {

                  searchControls.forEach(rec => {
                    var x = rec[item.DisplayAs];

                    var repeated = item.Values.filter(x => x.label.toLowerCase().trim() == rec[item.DisplayAs].toLowerCase().trim());
                    if (rec[item.DisplayAs] !== null && rec[item.DisplayAs] !== '' && rec[item.DisplayAs] !== ' ' && repeated.length < 1) {
                      item.Values.push({ label: rec[item.DisplayAs], value: rec[item.DisplayAs] });

                    }
                  });

                }
                item.Values = item.Values.sort((a, b) => {
                  return a.label.toLowerCase().trim().localeCompare(b.label.toLowerCase().trim());
                });
              });

              this.searchInputList = this.searchInputList.sort((a, b) => a.Sequence - b.Sequence);

            }
            this.loading = false;
            this.customLoader = false;
            this.displayPagination = false;
            this.buildForm();
          }
          else {
            this.loading = false;
            this.customLoader = false;

            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.customLoader = false;

        this.timeoutFunct(httpResponseError.message, false);
      });


  }

  callFunction(stuff) {

    if (this.searchLoader) {
      // this.loading = false;
      // this.customLoader = false;

      this.searchLoader = false;
    }
  }
  timeoutFunct(msg, isSuccess: boolean) {
    this.displayMessage = true;
    this.messageClass = isSuccess;
    this.message = msg;
    setTimeout(() => {
      this.message = '';
      this.displayMessage = false;
    }, environment.messageLifeSpan);
  }

  closeMessagePopup() {
    this.displayMessage = false;
  }


  private buildForm() {

    if (this.form) {
      this.form = new FormGroup({});
    }

    const formGroup = this.formBuilder.group({});
    var that = this;
    var count = 0;

    if (this.isDocuware) {

      if (this.searchableFieldModel != null) {

        this.searchableFieldModel.forEach(field => {
          formGroup.addControl(field.FieldName, that.formBuilder.control(null,
            {
              updateOn: Constants.formControlUpdateStrategy.change
            }));
          count += 1;
        });
      }

      else {
        formGroup.addControl("FULL_TEXT", that.formBuilder.control(null,
          {
            updateOn: Constants.formControlUpdateStrategy.change
          }));
        if (this.docuwareSearchControlModel[0]?.DocuwareFields) {

          this.docuwareSearchControlModel[0].DocuwareFields.forEach(field => {
            if (field.IsSearch) {
              formGroup.addControl(field.FieldName, that.formBuilder.control(null,
                {
                  updateOn: Constants.formControlUpdateStrategy.change
                }));
              count += 1;
            }
          });
        }
      }
    } else {
      if (this.searchInputList?.length > 0) {
        formGroup.addControl("FULL_TEXT", that.formBuilder.control(null,
          {
            updateOn: Constants.formControlUpdateStrategy.change
          }));
        this.searchInputList.forEach(field => {
          if (field.IsSearch) {
            if (field.FieldType === enumFieldTypes.enumInteger || field.FieldType === enumFieldTypes.enumDate
              || field.FieldType === enumFieldTypes.enumDecimal || field.FieldType === enumFieldTypes.enumCurrency) {
              formGroup.addControl(field.FieldName + 'From', that.formBuilder.control(null,
                {
                  updateOn: Constants.formControlUpdateStrategy.change
                }));

              formGroup.addControl(field.FieldName + 'To', that.formBuilder.control(null,
                {
                  updateOn: Constants.formControlUpdateStrategy.change
                }));

              count += 2;
            }
            else {
              formGroup.addControl(field.FieldName, that.formBuilder.control(null,
                {
                  updateOn: Constants.formControlUpdateStrategy.change
                }));
              count += 1;
            }

          }
        });
      }
    }

    this.form = formGroup;
  }
  DocumentViewerModel: boolean;

  DocumentViewerDialog() {
    this.DocumentViewerModel = true;
  }


  prepareMetadetaHeaders() {
    this.loading = true;
    this.headers = [];

    this.headers.push({ headerName: "DocumentId", fieldType: 'Numeric', sequence: -1 });
    this.headers.push({ headerName: 'View', fieldType: 'Text', sequence: 0 });
    if (this.searchInputList?.length > 0) {
      this.searchInputList.filter(
        x => x.DisplayAs !== "Full Text"
      ).
        forEach(metadata => {
          this.loading = true;
          if (metadata.IsDisplay) {
            this.headers.push({
              headerName: metadata.DisplayAs, fieldType: metadata.FieldType, sequence: metadata.Sequence,

            });
          }

          if (this.searchInputList?.length > 0 && metadata.FieldType == 'List') {
            this.filterDropdownSuggestion(metadata.DocumentTypeMetadataId, metadata.FieldName);
          }

        });
      this.headers = this.headers.sort((a, b) => a.sequence - b.sequence);
    }

    if (this.searchInputList?.length == 0) {
      this.timeoutFunct('Please add document type fields', false);
    }
  }

  resetFilter(isReset: boolean): Promise<void> {
    return new Promise((resolve) => {
      if (isReset) {
        this.form.reset();
      }

      this.tableVisible = false;
      this.searchFilterDataTemp = new Array<any>();
      this.searchRecords = new Array<any>();
      this.searchRecordsTemp = new Array<any>();
      this.totalRecords = 0;
      this.pageNumber = 1;
      this.displayClearButton = false;
      this.isLazyLoadingEnabled = false;
      this.metadataSearchModel = new Array<SearchMetadataModel>();
      setTimeout(() => {
        this.tableVisible = true;
        if (isReset) {
          this.performInitialSearch();
        }
        resolve();
      }, 1000);
    })

  }

  async onLazyLoad(event: LazyLoadEvent) {

    if (!event.rows || event.rows == this.lazyPageSize) {
      await this.resetFilter(false);
      this.isLazyLoadingEnabled = false;
    }
    else {
      this.isLazyLoadingEnabled = true;
    }


    const totalLoadedRecords = this.searchRecords.length;

    if (totalLoadedRecords >= this.totalRecords && this.searchRecords.length > 0) {
      return;
    }
    else {

      this.pageNumber = Math.floor((totalLoadedRecords) / this.lazyPageSize) + 1;
      if (!this.selectedDocumentType) {
        return;
      }

      this.metadataSearchModel = new Array<SearchMetadataModel>();
      this.displayClearButton = true;

      for (let searchBox of this.searchInputList) {
        if (!(searchBox.FieldName === 'FULL_TEXT')) {
          let searchDataItem = new SearchMetadataModel();
          if (searchBox.FieldType === enumFieldTypes.enumInteger || searchBox.FieldType === enumFieldTypes.enumDecimal
            || searchBox.FieldType === enumFieldTypes.enumCurrency
          ) {
            let searchValueFrom = this.form.controls[searchBox.FieldName + 'From']?.value;
            let searchValueTo = this.form.controls[searchBox.FieldName + 'To']?.value;
            if (parseFloat(searchValueFrom) > parseFloat(searchValueTo)) {
              this.timeoutFunct('Please apply appropriate ' + searchBox.FieldName + ' range', false);
              this.loading = false;
              return;
            }
            if (!this.searchFilterDataTemp?.includes(searchBox.FieldName)) {
              if (searchValueFrom) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.FieldValueFrom = searchValueFrom;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;

                this.metadataSearchModel.push(searchDataItem);
              }
              if (searchValueTo) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.FieldValueTo = searchValueTo;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;

                this.metadataSearchModel.push(searchDataItem);
              }
            }
          }

          else if (searchBox.FieldType === enumFieldTypes.enumDate) {
            let searchValueFrom = this.form.controls[searchBox.FieldName + 'From']?.value;
            let searchValueTo = this.form.controls[searchBox.FieldName + 'To']?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValueFrom || searchValueTo) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;
                if (searchValueFrom) {
                  const momentDateValueFrom = moment(searchValueFrom, 'MM/DD/YYYY');
                  let dateValueFrom = momentDateValueFrom.format('MM/DD/YYYY');
                  searchDataItem.FieldValueFrom = dateValueFrom;
                }
                if (searchValueTo) {
                  const momentDateValueTo = moment(searchValueTo, 'MM/DD/YYYY');
                  let dateValueTo = momentDateValueTo.format('MM/DD/YYYY');
                  searchDataItem.FieldValueTo = dateValueTo;
                }
                if (searchValueFrom && searchValueTo) {
                  const momentDateValueFrom = moment(searchValueFrom, 'MM/DD/YYYY');
                  const momentDateValueTo = moment(searchValueTo, 'MM/DD/YYYY');
                  if (momentDateValueFrom > momentDateValueTo) {
                    this.loading = false;
                    this.timeoutFunct('Please apply appropriate date range', false);
                    return;
                  }
                }
                this.metadataSearchModel.push(searchDataItem);
              }
            }
          }
          else {
            let searchValue = this.form.controls[searchBox.FieldName]?.value?.label
              ? this.form.controls[searchBox.FieldName]?.value?.label
              : this.form.controls[searchBox.FieldName]?.value;

            if (!this.searchFilterDataTemp.includes(searchBox.FieldName)) {
              if (searchValue) {
                searchDataItem.FieldName = searchBox.FieldName;
                searchDataItem.FieldType = searchBox.FieldType;
                searchDataItem.FieldValueFrom = searchValue;
                searchDataItem.FieldValueTo = searchValue;
                searchDataItem.DocumentTypeMetadataId = searchBox.DocumentTypeMetadataId;
                this.metadataSearchModel.push(searchDataItem);
              }
            }
          }
        } else {
          this.fullTextSearch = this.form.get('FULL_TEXT')?.value;
        }
      }


      this.sortField = event.sortField ? event.sortField : 'DocumentTypeInboxId';
      this.sortOrder = event.sortOrder;

      const sortColumnFieldType = this.getSortColumnFieldType(event.sortField);
      const sortColumn = event.sortField;
      const sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';

      const metadataFilters: SearchMetadataRequestModel = {
        DocumentTypeId: this.selectedDocumentType.DocumentTypeId,
        forCustomPage: true,
        IsAdvanceSearch: false,
        PageNumber: this.pageNumber,
        PageSize: this.lazyPageSize,
        SortColumn: sortColumn,
        SortColumnFieldType: sortColumnFieldType,
        SortOrder: sortOrder,
        MetadataSearch: this.metadataSearchModel
      };
      this.fullTextSearch = this.form.get('FULL_TEXT')?.value;

      this.loading = true;
      this.documentService.GetMetadataSearchData(this.fullTextSearch, metadataFilters)
        .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
        .subscribe((result: ResultOfT<PagedResult<DynamicDocumentTypeInbox>>) => {
          if (result.IsSuccess) {
            this.totalRecords = result?.ResponseModel?.TotalRecords || 0;
            const newRecords = result?.ResponseModel?.Data;
            var finalRecordList = [...this.searchRecords, ...newRecords];
            this.searchRecords = finalRecordList;
            if (this.searchRecords.length > 0) {
              this.showSearchPanel = true;
            }
            this.isLazyLoadingEnabled = true;
          }
        }, (httpResponseError) => {
          this.timeoutFunct(httpResponseError.message, false);
        });

    }
  }

  private getSortColumnFieldType(sortField: string): string {
    if (!sortField || !this.searchInputList) {
      return '';
    }

    const field = this.searchInputList.find(f => f.FieldName === sortField);
    return field?.FieldType || '';
  }

  performInitialSearch(): void {
    this.loading = true;
    this.pageNumber = 1;
    this.totalRecords = 0;
    this.searchRecords = [];
    this.isLazyLoadingEnabled = true;
    this.displayClearButton = false;
    this.onLazyLoad({
      first: 0,
      rows: this.lazyPageSize,
      sortField: 'DocumentTypeInboxId',
      sortOrder: -1
    });
  }

  /**
   * Waits for the ViewChild element to be available in the DOM
   */
  private waitForNutrientContainer(): Promise<HTMLElement> {
    return new Promise((resolve, reject) => {
      const maxAttempts = 20; // Maximum attempts to wait for the element
      let attempts = 0;

      const checkElement = () => {
        attempts++;

        if (this.nutrientViewerElement?.nativeElement) {
          const element = this.nutrientViewerElement.nativeElement;
          // Additional check to ensure element is in the DOM
          if (document.contains(element)) {
            console.log('Nutrient container found and ready');
            resolve(element);
            return;
          }
        }

        if (attempts >= maxAttempts) {
          reject(new Error('Nutrient container element not found after waiting'));
          return;
        }

        // Wait 100ms before next attempt
        setTimeout(checkElement, 100);
      };

      checkElement();
    });
  }

  /**
   * Ensures the Nutrient SDK container has proper dimensions before initialization
   */
  private ensureContainerDimensions(container: HTMLElement): void {
    if (!container) {
      throw new Error('Container element is null or undefined');
    }

    // Force the container to be visible and have dimensions
    container.style.display = 'block';
    container.style.visibility = 'visible';

    // Set minimum dimensions if not already set
    const computedStyle = window.getComputedStyle(container);
    const containerWidth = container.offsetWidth || parseInt(computedStyle.width) || 0;
    const containerHeight = container.offsetHeight || parseInt(computedStyle.height) || 0;

    console.log('Container dimensions before fix:', { width: containerWidth, height: containerHeight });

    if (containerWidth === 0) {
      container.style.width = '100%';
      container.style.minWidth = '800px';
      console.log('Setting container width to 100% with min-width 800px');
    }

    if (containerHeight === 0) {
      container.style.height = '600px';
      container.style.minHeight = '600px';
      console.log('Setting container height to 600px');
    }

    // Ensure parent containers are also visible
    let parent = container.parentElement;
    while (parent && parent !== document.body) {
      const parentStyle = window.getComputedStyle(parent);
      if (parentStyle.display === 'none') {
        parent.style.display = 'block';
      }
      if (parentStyle.visibility === 'hidden') {
        parent.style.visibility = 'visible';
      }
      parent = parent.parentElement;
    }

    // Force a reflow to ensure dimensions are applied
    container.offsetHeight;

    // Final validation
    const finalWidth = container.offsetWidth;
    const finalHeight = container.offsetHeight;
    console.log('Container dimensions after fix:', { width: finalWidth, height: finalHeight });

    if (finalWidth === 0 || finalHeight === 0) {
      throw new Error(`Container still has no dimensions: width=${finalWidth}, height=${finalHeight}. Please check CSS and ensure parent containers are properly sized.`);
    }
  }

}
